import { render, staticRenderFns } from "./SimilarRecipes.vue?vue&type=template&id=1fcc2af8&"
import script from "./SimilarRecipes.vue?vue&type=script&lang=js&"
export * from "./SimilarRecipes.vue?vue&type=script&lang=js&"
import style0 from "./SimilarRecipes.vue?vue&type=style&index=0&id=1fcc2af8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports